import { Group } from '../../lib/Group';

export const mockUserGroups: Group[] = [
    { id: 11493, title: 'Uefa' },
    { id: 11297, title: 'NF' },
    { id: 8, title: 'Wimbledon' },
    { id: 1234567, title: 'Test error 1' },
    { id: 3456789, title: 'Test error 2' },
];
